import { render, staticRenderFns } from "./BeneficiaryPhysical.vue?vue&type=template&id=f11707a0&scoped=true&"
import script from "./BeneficiaryPhysical.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryPhysical.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiaryPhysical.vue?vue&type=style&index=0&id=f11707a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11707a0",
  null
  
)

export default component.exports